module.exports = __webpack_public_path__ + "static/media/Novosady_zadni.81584192.md";